import { BuildingOffice2Icon, UserIcon } from "@heroicons/react/24/outline";
import {
    PlacementId,
    CommunityId,
    ReferenceBusinessId,
    ReferenceContactId,
} from "@sp-crm/core";
import React from "react";
import { Link } from "react-router-dom";

const baseClassName =
    "inline-flex items-center gap-1 text-sm text-brand-600 hover:text-brand-800 hover:underline";

export const CommunityLink: React.FC<{
    communityId: CommunityId;
    name: string;
    className?: string;
    onClick?: React.MouseEventHandler;
}> = ({ communityId, name, className, onClick }) => (
    <Link
        to={`/communities/show/${communityId}`}
        className={className ? `${baseClassName} ${className}` : baseClassName}
        onClick={onClick}>
        <BuildingOffice2Icon className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
        <span className="truncate">{name}</span>
    </Link>
);

export const ClientLink: React.FC<{
    clientId: PlacementId;
    name: string;
    className?: string;
    onClick?: React.MouseEventHandler;
}> = ({ clientId, name, className, onClick }) => (
    <Link
        to={`/clients/show/${clientId}`}
        className={className ? `${baseClassName} ${className}` : baseClassName}
        onClick={onClick}>
        <UserIcon className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
        <span className="truncate">{name}</span>
    </Link>
);

export const ReferenceContactLink: React.FC<{
    referenceContactId: ReferenceContactId;
    name: string;
    className?: string;
    onClick?: React.MouseEventHandler;
}> = ({ referenceContactId, name, className, onClick }) => (
    <Link
        to={`/references/contacts/show/${referenceContactId}`}
        className={className ? `${baseClassName} ${className}` : baseClassName}
        onClick={onClick}>
        <UserIcon className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
        <span className="truncate">{name}</span>
    </Link>
);

export const ReferenceBusinessLink: React.FC<{
    referenceBusinessId: ReferenceBusinessId;
    name: string;
    className?: string;
    onClick?: React.MouseEventHandler;
}> = ({ referenceBusinessId, name, className, onClick }) => (
    <Link
        to={`/references/organizations/show/${referenceBusinessId}`}
        className={className ? `${baseClassName} ${className}` : baseClassName}
        onClick={onClick}>
        <BuildingOffice2Icon className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
        <span className="truncate">{name}</span>
    </Link>
);
